/**
 * Named re-exports of the Shopify export target's shape.
 *
 * The column list, groups, N/A defaults, and price/SKU-like sets live in
 * `targets/shopify.ts`. This file re-exports them under the names used across
 * the mapper UI, automap, seed scripts, and tests (`SHOPIFY_COLUMNS`,
 * `COLUMN_GROUPS`, `NA_BY_DEFAULT`, etc.).
 */

import { shopifyTarget } from "./targets/shopify";

export const SHOPIFY_COLUMNS = shopifyTarget.columns;
export type ShopifyColumn = (typeof shopifyTarget.columns)[number];

export const COLUMN_GROUPS = shopifyTarget.columnGroups;

/** Columns that variant rules should add a priceDelta to. */
export const PRICE_LIKE_COLUMNS = shopifyTarget.priceLikeColumns;

/** Columns that variant rules should append a skuSuffix to. */
export const SKU_LIKE_COLUMNS = shopifyTarget.skuLikeColumns;

/** Shopify columns that are typically left blank on Monjolika's live store CSV. */
export const NA_BY_DEFAULT = shopifyTarget.naByDefault;
